<template>
  <div class="flex flex-col items-center gap-[12px] w-full">
    <div class="pb-[12px] w-full">
      <h2 class="text-[28px] font-bold text-[#3a3d44] text-center leading-[1.3]">Регистрация через email</h2>
    </div>
    <form class="flex flex-col items-center gap-[12px] w-full" @submit.prevent="handleSubmit">
      <UINewInput
        :model-value="email"
        placeholder="Email"
        type="email"
        disabled
        class="!w-[368px] max-md:!w-full"
        input-classes="!rounded-[12px] !border-[#d9e5ff]"
      />
      <UINewInput
        v-model="password"
        placeholder="Введите пароль"
        :type="showPassword ? 'text' : 'password'"
        class="!w-[368px] max-md:!w-full"
        input-classes="!rounded-[12px] !border-[#d9e5ff] w-full"
        :validation-rules="[
          { type: 'required', message: 'Введите пароль' },
          { type: 'minLength', value: 6, message: 'Пароль должен содержать более 6-ти символов' },
        ]"
        @update:validation-error="passwordError = $event"
      >
        <template #postfix>
          <div
            class="flex items-center justify-center p-1 cursor-pointer"
            @click="showPassword = !showPassword"
          >
            <Icon
              :name="showPassword ? 'mdi:eye-off' : 'mdi:eye'"
              class="text-2xl text-txopacity"
            />
          </div>
        </template>
      </UINewInput>
      <p v-if="serverError" class="text-[#f8465b] text-sm w-[368px] max-md:w-full">{{ serverError }}</p>
      <button
        type="submit"
        class="bg-primary rounded-[12px] py-3 w-[368px] max-md:w-full text-white font-bold text-base disabled:opacity-50"
        :disabled="loading || !!passwordError || !password"
      >
        <span v-if="loading" class="loader-inline mr-2" />
        Войти
      </button>
    </form>
    <div class="flex items-center justify-center gap-1.5 pt-[12px] text-sm text-[rgba(58,61,68,0.6)]">
      или
      <span class="text-primary cursor-pointer" @click="$emit('setMode', LoginMode.AUTH_TELEGRAM)">
        через Telegram
      </span>
    </div>
    <p class="font-normal text-xs text-center text-[rgba(58,61,68,0.6)] pt-[12px] w-[350px] max-md:w-full max-md:px-4">
      Продолжая, вы соглашаетесь с
      <a href="/pdf/oferta.pdf" target="_blank" class="underline !text-[rgba(58,61,68,0.6)] !font-normal">офертой</a>
      и даёте
      <a href="/pdf/consent.pdf" target="_blank" class="underline !text-[rgba(58,61,68,0.6)] !font-normal">согласие</a>
      на обработку данных в соответствии с
      <a href="/pdf/politic.pdf" target="_blank" class="underline !text-[rgba(58,61,68,0.6)] !font-normal">политикой в отношении обработки персональных данных</a>
    </p>
  </div>
</template>

<script setup lang="ts">
import { LoginMode } from '~/interfaces/login/UI';
import AuthService from '~/services/AuthService';

const emit = defineEmits<{
  (e: 'setMode', mode: LoginMode): void;
  (e: 'setExpiredAt', expiredAt: string): void;
  (e: 'setPassword', password: string): void;
}>();

const props = defineProps<{
  email: string;
  registrationId: number;
}>();

const password = ref('');
const passwordError = ref('');
const serverError = ref('');
const loading = ref(false);
const showPassword = ref(false);

const handleSubmit = async () => {
  if (!password.value || passwordError.value) return;
  loading.value = true;
  serverError.value = '';
  try {
    const { expiredAt } = await AuthService.registerStep2(props.registrationId, password.value);
    emit('setPassword', password.value);
    if (expiredAt) emit('setExpiredAt', expiredAt);
    emit('setMode', LoginMode.CONFIRM_CODE);
  } catch (error: any) {
    serverError.value = 'Не удалось завершить регистрацию. Попробуйте позже.';
  } finally {
    loading.value = false;
  }
};
</script>
